<template>
  <div>
    <div>
      <v-btn
        :disabled="disabled"
        @click="setDialog(true)"
        aria-label="Update Service Area"
        class="pa-0"
        color="primary"
        text
        small
        title="Update Service Area"
      >
        {{ serviceAreaId || "unassigned" }}
      </v-btn>
    </div>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <service-area-form
        :organization="organization"
        :serviceAreaId="serviceAreaId"
        @setDialog="setDialog"
      ></service-area-form>
    </v-dialog>
  </div>
</template>

<script>
import ServiceAreaForm from "./ServiceAreaForm";

export default {
  components: { ServiceAreaForm },
  computed: {},
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    organization: {
      default: null,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    serviceAreaId: {
      default: null,
    },
  },
};
</script>
